import Vue from 'vue'
import LZString from '@/components/utils/LZString'

export default {
  install() {
    Vue.prototype.$lzstring = LZString
  }
}
